import { render } from "./CLoading.html?vue&type=template&id=3ade71a2&ts=true"
import script from "./CLoading.vue?vue&type=script&lang=ts"
export * from "./CLoading.vue?vue&type=script&lang=ts"

import "./CLoading.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/builds/chatplace/app-link/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__